<template>
  <div class="detail">
    <div class="nav">
      <img
        class="back"
        src="../../../assets/workOrder/back.png"
        alt=""
        @click="onClickBack"
      />
      <p class="title">工单详情</p>
      <div></div>
    </div>
    <div class="head_info">
      <div class="top">
        <div class="left">
          {{ (queryInfo.bizName && queryInfo.bizName.split("")[0]) || "-" }}
        </div>
        <div class="right">
          <div class="text">
            <div class="bizName">{{ `${queryInfo.bizName || "--"}` }}</div>
            <div class="sgInfo">
              <span class="goodstype">{{ queryInfo.goodsType || "--" }}</span>
              <span class="goodsWeight"
                >{{ queryInfo.goodsWeight || 0 }}吨</span
              >
            </div>
          </div>
          <div class="date">
            <p>开航时间：{{ queryInfo.khTime }}</p>
          </div>
        </div>
      </div>
      <div class="middle flex">
        <div class="left">
          <div>
            <p class="tip">始发地：</p>
            <p class="place">{{ queryInfo.originPlace || "--" }}</p>
          </div>
          <div>
            <p class="tip">目的地：</p>
            <p class="place">{{ queryInfo.destinationPlace || "--" }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="assist">
      <div class="titname">
        <span
          >接单人：<span>{{ queryInfo.acceptPerson || "--" }}</span></span
        >
      </div>
      <div class="titname">
        <span
          >协助人：<span>{{ queryInfo.helpPerson || "无" }}</span></span
        ><van-icon name="arrow-down" @click="showPicker = true" />
      </div>
    </div>
    <div class="list_cell" v-for="item in list" :key="item.id">
      <div class="top flex">
        <img class="icon" src="@/assets/workOrder/shipIcon.png" />
        <div class="inner flex">
          <p class="title">{{ item.shipName }}</p>
          <div class="btns">
            <span
              v-if="item.state == 1 && role != 5"
              class="btn btn1"
              @click="handleAction(0, item)"
              >提交</span
            >
            <span v-if="item.state == 4" class="btn btn2">已通过审核</span>
            <span
              v-if="item.state == 2"
              class="btn btn3"
              @click="handleAction(2, item)"
              >重新提交</span
            >
            <span v-if="item.state == 3" class="btn btn4">已完成提交</span>
            <span v-if="item.state == 5" class="btn btn5">不通过审核</span>
          </div>
        </div>
      </div>
      <div class="snstyle">sn：{{ item.csn || "--" }}</div>
      <div class="line" v-if="item.state != 1"></div>
      <div class="view">
        <div v-if="item.state != 1">
          <img
            class="line1"
            v-if="item.state == 3"
            src="../../../assets/workOrder/line1.png"
            alt=""
          />
          <img
            class="line2"
            v-if="item.state == 4 || item.state == 2"
            src="../../../assets/workOrder/line2.png"
            alt=""
          />
        </div>
        <div class="inner" v-if="item.state != 1">
          <p class="text_info">
            安装人员：<span>{{ item.installPerson }}</span>
          </p>
          <p class="text_info">
            提交时间：<span>{{ item.submitTime }}</span>
          </p>
          <p class="text_info" v-if="item.state == 4">
            审核时间：<span>{{ item.checkTime }}</span>
          </p>
          <p class="text_info" v-if="item.state == 2">
            驳回时间：<span>{{ item.rejectTime }}</span>
          </p>
        </div>
      </div>
      <!-- 展示驳回理由 -->
      <div v-if="item.state == 2">
        <van-collapse v-model="activeNames">
          <van-collapse-item
            title="驳回理由"
            title-class="titco"
            label-class="lasty"
            :name="item.id"
            >{{ item.rejectReason }}
          </van-collapse-item>
        </van-collapse>
      </div>
    </div>
    <van-popup v-model="showAction" position="center" class="showAction">
      <div class="wrapper">
        <div class="block" v-if="type == 2">
          <p class="title">重新提交：</p>
          <van-checkbox-group v-model="result" direction="horizontal">
            <!-- :disabled="kdhg" -->

            <van-checkbox
              v-for="item in installList"
              :key="item.id"
              :name="item.name"
              class="horizontallist"
            >
              {{ item.name }}</van-checkbox
            >
          </van-checkbox-group>
          <!--   <textarea
            v-model="reason"
            class="area"
            maxlength="50"
            placeholder="重新提交原因："
          ></textarea> -->
          <div class="btns">
            <div class="reject" @click="onClickState(1)">取消</div>
            <div class="pass" @click="onClickState(2)">提交</div>
          </div>
        </div>
        <div class="block" v-if="type == 0">
          <p class="title">安装人员：</p>
          <van-checkbox-group v-model="result" direction="horizontal">
            <!-- :disabled="kdhg" 禁用的 -->

            <van-checkbox
              v-for="item in installList"
              :key="item.id"
              :name="item.name"
              class="horizontallist"
            >
              {{ item.name }}</van-checkbox
            >
          </van-checkbox-group>
          <div class="btns">
            <div class="reject" @click="onClickState(1)">取消</div>
            <div class="pass" @click="onClickState(0)">提交</div>
          </div>
        </div>
        <!-- <div class="block" v-if="type == 3">
          <p class="title">协助人员：</p>
          <van-checkbox-group v-model="result" direction="horizontal">

            <van-checkbox
              v-for="item in installList"
              :key="item.id"
              :name="item.name"
              class="horizontallist"
            >
              {{ item.name }}</van-checkbox
            >
          </van-checkbox-group>
          <div class="btns">
            <div class="reject" @click="onClickState(1)">取消</div>
            <div class="pass" @click="onClickState(3)">提交</div>
          </div>
        </div> -->
      </div>
    </van-popup>

    <van-popup v-model="showPicker" round position="bottom">
      <van-picker
        show-toolbar
        value-key="name"
        :columns="installListpik"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import {
  orderDetail,
  sumbitOrder,
  WorkUserList,
  updateWordInfo,
} from "@/utils/network/interface";
export default {
  name: "orderDetail",
  data() {
    return {
      role: "",
      //
      value: "",
      showPicker: false,
      //
      kdhg: false,
      activeNames: [],
      result: [],
      queryInfo: {},
      queryInfoid: {},
      list: [],
      showAction: false,
      type: true,
      currenItem: {},
      reason: "",
      installPerson: "",
      compoment: "",
      installList: [],
      installListpik: [],
    };
  },
  created() {
    this.queryInfoid = JSON.parse(this.$route.query.info);
    this.role = this.$route.query.role;
  },
  mounted() {
    this.getDetail();
    this.installFrom();
    this.installFrom1();
    // localStorage.setItem("path","workList3")
  },
  methods: {
    //
    onConfirm(value) {
      console.log(value);
      updateWordInfo({
        id: this.queryInfo.id,
        helpPerson: value.name || "",
      }).then((res) => {
        if (res.code == 200) {
          this.getDetail();
          this.value = "";
        }
      });
      this.value = value;
      this.showPicker = false;
    },
    //
    installFrom() {
      WorkUserList().then((res) => {
        if (res.code === 200) {
          let arr = res.data;
          arr.unshift({
            name: "无",
            id: "999",
          });
          this.installListpik = arr;
        }
      });
    },
    installFrom1() {
      WorkUserList().then((res) => {
        if (res.code === 200) {
          this.installList = res.data;
        }
      });
    },
    getDetail() {
      orderDetail({ id: this.queryInfoid.id }).then((res) => {
        if (res.code === 200) {
          this.list = res.data.details;
          this.queryInfo = res.data.workOrder;
          console.log(res, "321");
        }
      });
    },
    onClickBack() {
      this.$router.go(-1);
      // this.$router.replace({
      //   path:"/workOrder/order",
      //   query:{
      //     compoment:"workList3"
      //   }
      // })
    },
    handleAction(type, info) {
      // this.kdhg = false;
      let dg = [];
      if (info.installPerson && (type == 0 || type == 2)) {
        // this.kdhg = true;
        dg = info.installPerson.split(",");
        this.result = dg;
      }
      if (info.helpPerson) {
        // this.kdhg = true;
        dg = info.helpPerson.split(",");
        this.result = dg;
      }
      console.log(info);
      console.info(dg);
      this.currenItem = info;
      this.type = type;
      this.showAction = true;
    },
    onClickState(type) {
      if (type == 1) {
        this.result = [];
        this.currenItem = {};
        this.type = "";
        this.showAction = false;
        this.reason = "";
        this.installPerson = "";
        return;
      } else if (type == 2) {
        let arrs = this.result + "";
        // this.reason = arrs
        this.installPerson = arrs;
        if (this.installPerson.length <= 0)
          return this.$toast("请先选择安装人员");
        sumbitOrder({
          id: this.currenItem.id,
          installPerson: this.installPerson,
        }).then((res) => {
          if (res.code == 200) {
            this.getDetail();
            this.currenItem = {};
            this.type = "";
            this.showAction = false;
            this.reason = "";
            this.installPerson = "";
            this.result = [];
          }
        });
      } else if (type == 0) {
        let arrs = this.result + "";
        console.log(arrs);
        this.installPerson = arrs;
        if (this.installPerson.length <= 0)
          return this.$toast("请先选择安装人员");
        sumbitOrder({
          id: this.currenItem.id,
          installPerson: this.installPerson,
        }).then((res) => {
          if (res.code == 200) {
            this.getDetail();
            this.currenItem = {};
            this.type = "";
            this.showAction = false;
            this.reason = "";
            this.installPerson = "";
            this.result = [];
          }
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.detail {
  background: url("../../../assets/workOrder/detailBg.png") 0 0 no-repeat;
  background-size: 100% 240px;
  min-height: 240px;
  padding-top: 36px;

  .nav {
    display: flex;

    .title {
      height: 16px;
      font-size: 16px;
      font-weight: 400;
      text-align: center;
      color: #ffffff;
      line-height: 16px;
      margin: 0 auto;
      // margin-left: -26px;
    }

    .back {
      width: 18px;
      height: 18px;
      margin-top: -2px;
      margin-left: 8px;
    }

    div {
      width: 18px;
      margin-right: 8px;
    }
  }

  .head_info {
    margin: 0 auto;
    margin-top: 20px;
    width: 95%;
    background-color: #ffffff;
    border-radius: 5px;
    padding: 13px 8px;

    .top {
      display: flex;
      margin-bottom: 10px;
      border-bottom: 1px solid #eeeeee;
      padding-bottom: 10px;

      .left {
        flex: 0 0 40px;
        height: 40px;
        font-size: 20px;
        line-height: 40px;
        text-align: center;
        background: #44b1f9;
        border-radius: 6px;
        color: #fff;
        margin-right: 10px;
      }

      .right {
        .text {
          display: flex;
          margin-bottom: 5px;
        }

        .date {
          font-size: 12px;
          color: #666;
        }
      }

      .bizName {
        font-size: 16px;
        font-family: Source Han Sans CN, Source Han Sans CN-Medium;
        font-weight: 500;
        color: #333333;
        padding: 2px 0;
        line-height: 16px;
        margin-bottom: 2px;
      }

      .sgInfo {
        span {
          display: inline-block;
          padding: 2px 5px;
          font-size: 12px;
          line-height: 1.1;
        }

        .goodstype {
          margin-right: 10px;
          background: rgba(31, 181, 74, 0.15);
          color: #1fb54a;
        }

        .goodsWeight {
          margin-right: 10px;
          background: rgba(255, 0, 0, 0.15);
          color: #ff0000;
        }
      }
    }

    .middle {
      vertical-align: middle;
      border-radius: 5px;
      color: #333;
      align-items: center;
      justify-content: space-between;

      .left {
        background: url("../../../assets/workOrder/itemLeft.png") left center
          no-repeat;
        background-size: 8px 44px;
        min-height: 44px;
        padding-left: 15px;

        > div:first-child {
          margin-bottom: 6px;
        }

        .tip,
        .place {
          display: inline-block;
          vertical-align: middle;
          font-size: 13px;
          line-height: 28px;
        }

        .tip {
          color: #999;
          margin-right: 5px;
        }

        .place {
          font-weight: bold;
          color: #000;
        }
      }
    }
  }
  .assist {
    margin: 0 auto;
    margin-top: 10px;
    width: 95%;
    background-color: #ffffff;
    border-radius: 5px;
    padding: 13px 8px 1px;
    .titname {
      color: #999999;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 15px;
    }
  }
  .action_view {
    margin: 0 auto;
    margin-top: 10px;
    width: 95%;
    height: 48px;
    background-color: #ffffff;
    border-radius: 5px;
  }

  .list_cell {
    margin: 0 auto;
    margin-top: 10px;
    width: 95%;
    background-color: #ffffff;
    border-radius: 5px;
    padding-left: 15px;
    padding-right: 15px;
    margin-bottom: 10px;

    /deep/.titco {
      font-size: 14px;
      font-weight: 500;
      font-family: Source Han Sans CN, Source Han Sans CN-Medium;
      color: #666666;
    }

    /deep/.van-collapse-item__content {
      font-size: 12px;
      font-weight: normal;
      font-family: Source Han Sans CN, Source Han Sans CN-Medium;
      color: #999999;
    }

    .snstyle {
      color: #999;
      margin-bottom: 10px;
      padding-left: 45px;
    }
    .line {
      width: 90%;
      height: 1px;
      background: #eeeeee;
      margin: 0 auto;
      margin-bottom: 10px;
    }

    .view {
      display: flex;

      .line1 {
        width: 4px;
        height: 33px;
        // margin-top: 20px;
        margin-right: 20px;
        margin-left: 10px;
        margin-top: 2px;
      }

      .line2 {
        width: 4px;
        height: 57px;
        // margin-top: 20px;
        margin-right: 20px;
        margin-left: 10px;
        margin-top: 2px;
      }
    }

    .top {
      width: 100%;
      padding: 12px 0 6px;
      align-items: center;

      .icon {
        flex: 0 0 28px;
        display: block;
        width: 28px;
        height: 28px;
        margin-right: 15px;
      }

      .inner {
        flex: 0 0 calc(100% - 43px);
        justify-content: space-between;
        line-height: 28px;
        font-size: 14px;

        .btn {
          display: block;
          height: 28px;
          line-height: 26px;
          border-width: 1px;
          border-style: solid;
          padding: 0 10px;
          min-width: 66px;
          text-align: center;
          border-radius: 30px;

          &1 {
            background: #44b1f9;
            border-color: #44b1f9;
            color: #fff;
          }

          &2 {
            background: #999999;
            border-color: #999999;
            color: #fff;
          }

          &3 {
            background: rgba(68, 177, 249, 0.15);
            border-color: #44b1f9;
            color: #44b1f9;
          }

          &4 {
            background: rgba(153, 153, 153, 0.15);
            border-color: #999;
            color: #999;
          }
          &5 {
            // background: rgba(153, 153, 153, 0.15);
            border-color: red;
            color: red;
          }
        }
      }
    }

    .inner {
      font-size: 14px;
      // padding: 10px 0;
      bottom: 1px solid #999999;
      line-height: 2;
    }

    .text_info {
      height: 12px;
      font-size: 12px;
      font-family: Source Han Sans CN, Source Han Sans CN-Medium;
      font-weight: 500;
      text-align: center;
      color: #999999;
      line-height: 12px;
      text-align: left;
      margin-bottom: 12px;
    }
  }

  .showAction {
    width: 320px;
    // height: 250px;
    // min-height: 200px;
    max-height: 300px;
    background: #ffffff;
    border-radius: 20px;
    padding: 20px;
    line-height: 2;
    font-size: 14px;
    font-family: Source Han Sans CN, Source Han Sans CN-Medium;
    font-weight: 500;
    text-align: left;
    color: #666666;

    .title {
      margin-bottom: 10px;
    }

    .horizontallist {
      margin-bottom: 12px;
    }

    .area {
      margin: 0 auto;
      width: 100%;
      height: 107px;
      background: #eeeeee;
      border: 1px solid #44b1f9;
      border-radius: 5px;
      box-sizing: border-box;
      padding: 10px;
      resize: none;
    }

    .btns {
      margin-top: 30px;
      text-align: center;
      width: 100%;

      .reject {
        width: 88px;
        height: 28px;
        border-radius: 5px;
        background-color: #999999;
        color: white;
        text-align: center;
        line-height: 28px;
        display: inline-block;
        margin: 0 15px;
      }

      .pass {
        width: 88px;
        height: 28px;
        border-radius: 5px;
        color: white;
        text-align: center;
        line-height: 28px;
        background-color: #44b1f9;
        display: inline-block;
        margin: 0 15px;
      }
    }
  }
}
</style>